import React from 'react';
import { Line } from 'react-chartjs-2';
import DynamicAttribution from '@/components/shared/DynamicAttribution';

interface SleepTabProps {
  athleteData: any;
  isDark: boolean;
  generateSleepChart: () => any;
  getChartOptions: (title: string, hasSecondaryAxis?: boolean) => any;
  dataSources?: string[];
}

const SleepTab: React.FC<SleepTabProps> = ({ athleteData, isDark, generateSleepChart, getChartOptions, dataSources = ['whoop'] }) => {
  return (
    <div className={`cgm-card rounded-2xl p-8 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
      <div className="flex flex-col h-96 mb-6">
        <Line
          data={generateSleepChart()}
          options={getChartOptions('Sleep Quality & Duration', true)}
        />
        <DynamicAttribution sources={dataSources} />
      </div>
    </div>
  );
};

export default SleepTab; 